export default __webpack_public_path__ + "static/media/2.231c3b17.png";